// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1aaGa","tab":"Tabs_tab__3_MWE","tabActive":"Tabs_tabActive__saFu1"};